module.exports = __webpack_public_path__ + "web/img/tpsn_status_20.fbded87f.png";